import { TableStateType } from 'hooks';

import { SortDirection } from './types';

export const getSortingAndPaginationQuery = <T extends object>(tableState: TableStateType<T>) => ({
  pagination: {
    page: tableState.pageIndex + 1,
    pageSize: tableState.pageSize,
  },
  sorting:
    tableState.sortBy.length > 0
      ? {
          sortField: tableState.sortBy[0].id,
          sortDir: tableState.sortBy[0]?.desc ? SortDirection.Desc : SortDirection.Asc,
        }
      : undefined,
});
